import { useEffect, useState } from "react";
import { useSnackbar } from "notistack";
import { mercureSubscribe } from "../../services/mercure";
import { getCaseLink } from "../../services/Product/ProductService/productService";
import { useCurrentUser } from "../../provider/CurrentUserProvider";
import { MercureNotification } from "../../types/Mercure/MercureNotification";
import { ProductUnion } from "../../types/ProductUnion";

type CaseNotificationsProps = {
  product: ProductUnion;
  setHasUpdates: Function;
  refreshPage: Function;
};

const CaseNotifications = ({ product, setHasUpdates, refreshPage }: CaseNotificationsProps) => {
  const [notification, setNotification] = useState<MercureNotification | null>(null);
  const currentUser = useCurrentUser();
  const { enqueueSnackbar } = useSnackbar();

  useEffect(() => {
    return mercureSubscribe(product["@id"], setNotification);
  }, [product]);

  useEffect(() => {
    if (!notification || notification.backofficeUser === currentUser["@id"]) {
      return;
    }

    setHasUpdates(true);
    if (!!notification.backofficeUser && notification.backofficeUser !== "/backoffice_users/13") {
      showCaseUpdate(notification);
    } else {
      showSystemNotice(notification);
    }
  }, [notification]);

  const showCaseUpdate = (caseUpdate: MercureNotification) => {
    setHasUpdates(true);
    enqueueSnackbar("", {
      variant: "caseRefreshNotification",
      refreshPage,
      caseUpdate,
    });
  };

  const showSystemNotice = (notification: MercureNotification) => {
    if (
      notification.type !== "historyLog" ||
      notification.historyLog?.type !== "note" ||
      notification.historyLog.note.pinned === true
    ) {
      return;
    }
    enqueueSnackbar("", {
      variant: "systemNoteNotification",
      systemNote: notification.historyLog.note,
      caseLink: getCaseLink(product),
    });
  };
  return null;
};
export default CaseNotifications;
